<template>
  <svg
    :width="width ? width : height ? height * (17 / 12) : 17"
    :height="height ? height : width ? width * (12 / 17) : 12"
    viewBox="0 0 17 12"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M.1685 5.8653l5.5172 5.005c.3355.3046.8799.0709.8799-.3786V7.0321h6.2896v4.121c0 .2845.2345.515.5241.515h2.0966c.2896 0 .5241-.2305.5241-.515V6.0017c0-1.1377-.9389-2.0605-2.0965-2.0605h-7.338V.4817c0-.4488-.5437-.6832-.8798-.3786L.1685 5.108a.5095.5095 0 0 0 0 .7572z"
      :fill="iconColor"
      fill-rule="nonzero"
    />
  </svg>
</template>

<script>
export default {
  name: 'left',
  props: {
    iconColor: {
      type: String,
      default: '#F94094',
    },
    height: {
      type: Number,
      required: false,
    },
    width: {
      type: Number,
      required: false,
    },
  },
};
</script>
